import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

interface AuthState {
    access_token: string | null;
    refresh_token: string | null;
    user: Record<string, any>;
}
interface AuthContextProps {
    authState: AuthState;
    setAuthState: (authInfo: AuthState) => void;
    logout: () => void;
    isAuthenticated: () => boolean;
    isAdmin: () => boolean;
    isManager: () => boolean;
}

const useAuth = (): AuthContextProps => {
  const auth = useContext(AuthContext);
  if (!auth) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return auth;
};

export default useAuth;
